import { render, staticRenderFns } from "./section-orders.vue?vue&type=template&id=03334d4c&scoped=true&"
import script from "./section-orders.vue?vue&type=script&lang=js&"
export * from "./section-orders.vue?vue&type=script&lang=js&"
import style0 from "./section-orders.vue?vue&type=style&index=0&id=03334d4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03334d4c",
  null
  
)

export default component.exports